import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgLinkedin = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width="1em" height="1em" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<clipPath id="a"><path d="M0 0h32v32H0z" /></clipPath><g clipPath="url(#a)"><path fill="currentColor" d="M32 19.444v11.852h-6.852V20.26c0-2.778-1-4.666-3.481-4.666-1.89 0-3.037 1.259-3.519 2.481-.185.481-.222 1.074-.222 1.704v11.518h-6.852c.074-18.703 0-20.63 0-20.63h6.852v3h-.037c.889-1.444 2.518-3.48 6.222-3.48 4.519 0 7.889 2.925 7.889 9.258zM7.704 4.26c.037 2-1.482 3.593-3.852 3.593h-.074C1.48 7.852 0 6.259 0 4.259S1.556.704 3.889.704s3.815 1.555 3.815 3.555zM.407 10.667H7.26v20.63H.407z" /></g></svg>;
export default SvgLinkedin;